/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { TranslationService } from '@gh/core-mls';
import { ManualGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';

@Injectable()
export class JobSpecTemplateGridDefinition extends ManualGridDefinition {

  constructor(private translationService: TranslationService) {
    super();
  }

  buildGridOptions(): GridOptions {
    return { getRowId: (params) => String(params.data.id)};
  }

  buildColumnDefs(): ColDef[] {
    return [{
      field: 'name',
      width: 250,
      headerName: this.translationService.get('lbl_name'),
    }, {
      field: 'memo',
      headerName: this.translationService.get('lbl_description'),
    }];
  }

}
